import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class AddTimeRequest implements ISerialize {
    public Bib: number | null;

    public ContestantID: number;

    public ForcedLap: number | null;

    public ForceFinish: boolean;

    public RaceContestantID: number;

    public StationID: number;

    public StationRoleID: number;

    public Time: Date;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Bib?: number | null;
        ContestantID?: number;
        ForcedLap?: number | null;
        ForceFinish?: boolean;
        RaceContestantID?: number;
        StationID?: number;
        StationRoleID?: number;
        Time?: Date;
    }) {
        this.Bib = values.Bib ?? null;

        this.ContestantID = values.ContestantID ?? 0;

        this.ForcedLap = values.ForcedLap ?? null;

        this.ForceFinish = values.ForceFinish ?? false;

        this.RaceContestantID = values.RaceContestantID ?? 0;

        this.StationID = values.StationID ?? 0;

        this.StationRoleID = values.StationRoleID ?? 0;

        this.Time = values.Time ?? new Date('1970-01-01T00:00:00.000');
    }

    public serialize(): string {
        return (
            '{' +
            `"Bib": ${JSON.stringify(this.Bib)}` +
            ',' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"ForcedLap": ${JSON.stringify(this.ForcedLap)}` +
            ',' +
            `"ForceFinish": ${JSON.stringify(this.ForceFinish)}` +
            ',' +
            `"RaceContestantID": ${JSON.stringify(this.RaceContestantID)}` +
            ',' +
            `"StationID": ${JSON.stringify(this.StationID)}` +
            ',' +
            `"StationRoleID": ${JSON.stringify(this.StationRoleID)}` +
            ',' +
            `"Time": ${'"' + formatDateIso(this.Time) + '"'}` +
            '}'
        );
    }

    /**
     * Creates an instance of AddTimeRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Bib?: number | null;
        ContestantID?: number;
        ForcedLap?: number | null;
        ForceFinish?: boolean;
        RaceContestantID?: number;
        StationID?: number;
        StationRoleID?: number;
        Time?: Date;
    }): AddTimeRequest {
        return new AddTimeRequest(values);
    }

    public static _FromServerJson(json: any): AddTimeRequest {
        return new AddTimeRequest({
            Bib: json.Bib ?? null,
            ContestantID: json.ContestantID,
            ForcedLap: json.ForcedLap ?? null,
            ForceFinish: json.ForceFinish,
            RaceContestantID: json.RaceContestantID,
            StationID: json.StationID,
            StationRoleID: json.StationRoleID,
            Time: json.Time instanceof Date ? json.Time : new Date(json.Time),
        });
    }

    /**
     * Creates an instance of AddTimeRequest from another instance of AddTimeRequest.
     * @param other The AddTimeRequest you want to clone
     * @returns A cloned AddTimeRequest
     */
    public static FromOther(other: AddTimeRequest): AddTimeRequest {
        return AddTimeRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return AddTimeRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'AddTimeRequest';
}
